import React, { useState, useEffect } from 'react';
import http from '../../service'
import IndicatorsDetails from '../../Components/IndicatorsDetails';
import MaternityIcon from "../../images/MaternityIcon";
import * as S from './MaternityDetails.style';

const MaternityDetails = ({ setModal }) => {
  const [data, setData] = useState();

  useEffect(() => {
    http.get(`lot/getLotDetailDashByGreenery?stage=MATERNIDADE`)
      .then(({ data }) => setData(data.data.map((item) => ({
        ...item,
        label: item.greenery_name,
        actualPercentage: item.percentualPlanted,
        plannedPercentage: item.percentualPlan,
        percentualPlan: item.percentualPlan
      }))))
      .catch((err) => setModal({ isOpen: true, text: err.message }))
  }, [])

  const tableItems = [
    { label: 'Hortaliça', name: 'label' },
    { label: 'Plantado', name: 'actualQuantity' },
    { label: 'Percentual Plantado', name: 'actualPercentage' },
    { label: 'Percentual Planejado', name: 'percentualPlan' },
  ]

  const maternityInfo = {
    tableItems,
    label: "maternidade",
    shortLabel: "Hortaliça",
    units: 485,
    color: "#16c4c4",
    icon: MaternityIcon,
    link: '/indicadores/maternidade',
    path: ['maternidade'],
    data: data || []
  }
  return (
    <S.MaternityDetails>
      <IndicatorsDetails {...maternityInfo} />
    </S.MaternityDetails>
  );
};

export default MaternityDetails;
